var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.053 2.046L10 2l-.053.046H3.75L0 6.955l9.326 10.3L10 18l.675-.745L20 6.955l-3.75-4.91h-6.197zm-1.27 1H4.658l.65 2.983 3.473-2.983zM6.35 6.454h7.3L10 3.318 6.35 6.454zm8.34-.425l-3.473-2.983h4.124l-.65 2.983zM10 15.95l4.196-8.495H5.804L10 15.95zm1.845-1.477l3.466-7.018h2.888l-6.354 7.018zm3.776-8.018h2.738l-2.13-2.788-.608 2.788zM3.771 3.666l.608 2.788H1.641l2.13-2.788zm4.384 10.806L1.8 7.454h2.888l3.466 7.018z",
    fill: "#572DA5"
  })));
}
SvgBonusIcon.displayName = 'BonusIcon';
export default SvgBonusIcon;